import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVDropdown } from "../../../shared/JVDropdown";
import { Fetch } from "../../../shared/Fetch";
import { IWorkStream } from "./WorkStreamList";
import { InputTextarea } from "primereact/inputtextarea";
import { ILogin } from "../../../models/Login";

const status_Name_By_Assignee = [
  { name: "Created", value: "Created" },
  { name: "Pending", value: "Pending" },
  { name: "Under Review", value: "Under Review" },
  { name: "Received", value: "Received" },
  { name: "Documentation Pending", value: "Documentation Pending" },
  { name: "Uploaded", value: "Uploaded" },
];

const status_Name_By_ProposalWriter_V = [
  { name: "Verified", value: "Verified" },
  { name: "Non-Compliant", value: "Non-Compliant" },
];

const status_Name_By_BidManager = [
  { name: "Approved", value: "Approved" },
  { name: "Rejected", value: "Rejected" },
];

const status_Name_By_ProposalWriter = [{ name: "Closed", value: "Closed" }];

// if (_roles.includes(1) || _roles.includes(26))
// [...status_Name_By_Assignee, ...status_Name_By_ProposalWriter_V, ...status_Name_By_BidManager, ...status_Name_By_ProposalWriter]

// else if (_roles.includes(53)) // Bid-Manager
//if (workStream?.status === "Verified" || workStream?.status === "Approved" || workStream?.status === "Rejected")
// [...status_Name_By_BidManager]

// else if (_roles.includes(55)) // Proposal-Writer
//if (workStream?.status === "Uploaded" || workStream?.status === "Verified" || workStream?.status === "Non-Compliant" || workStream?.status === "Rejected")
// [...status_Name_By_ProposalWriter_V]
// else if (workStream?.status === "Approved")
// [...status_Name_By_ProposalWriter]

// else
//if (workStream?.status === "Uploaded" || workStream?.status === "Non-Compliant" || workStream?.status === "Rejected" || workStream?.status === "Closed")
// []
// else [...status_Name_By_Assignee]

const schema = yup.object({
  status: yup.string().required("Status is required"),
});

interface IProps {
  visible: boolean;
  onHide: () => void;
  workStream: IWorkStream | null;
  toast: any;
  onSuccess: () => void;
}

const WorkStreamStatus = ({ visible, onHide, workStream, toast, onSuccess }: IProps) => {
  const [statusComment, setStatusComment] = useState<string>("");
  const [showStatus, setShowStatus] = useState<Array<{ name?: string; value?: string }>>([]);
  const [loading, setLoading] = useState(false);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm<{ status: string }>({
    resolver: yupResolver(schema),
    defaultValues: { status: "" },
  });

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  let _roles: Array<number> = [];
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });

  // useEffect(() => {
  //   if (_roles.includes(1) || _roles.includes(26) || _roles.includes(56)) {
  //     setShowStatus([...status_Name_By_Assignee, ...status_Name_By_ProposalWriter_V, ...status_Name_By_BidManager, ...status_Name_By_ProposalWriter]);
  //   } else {
  //     if (workStream !== null && (workStream?.status === "Uploaded" || workStream?.status === "Verified" || workStream?.status === "Non-Compliant") && _roles.includes(55)) {
  //       // Proposal-Writer
  //       setShowStatus(status_Name_By_ProposalWriter_V);
  //     } else if (workStream !== null && (workStream?.status === "Verified" || workStream?.status === "Approved" || workStream?.status === "Rejected") && _roles.includes(53)) {
  //       // Bid-Manager
  //       setShowStatus(status_Name_By_BidManager);
  //     } else if (workStream !== null && workStream?.status === "Approved" && workStream.assigned_To_ID !== undefined && workStream.assigned_To_ID !== null && workStream.assigned_To_ID > 0 && workStream.assigned_To_ID === loginObj.id) {
  //       // Bid-Manager
  //       setShowStatus(status_Name_By_ProposalWriter);
  //     } else if (workStream !== null && workStream?.status !== "Closed" && workStream?.status !== "Uploaded" && workStream?.status !== "Verified" && workStream?.status !== "Approved" && workStream?.assigned_To_ID !== undefined && workStream?.assigned_To_ID !== null && workStream?.assigned_To_ID > 0 && workStream.assigned_To_ID === loginObj.id) {
  //       const assigneeStatus = workStream?.status === "Created" ? status_Name_By_Assignee : status_Name_By_Assignee.filter((s) => s.value !== "Created");
  //       // setShowStatus(status_Name_By_Assignee);
  //       setShowStatus(assigneeStatus);
  //     } else {
  //       setShowStatus([]);
  //     }
  //   }

  //   if (visible && workStream) {
  //     reset({ status: workStream.status ?? "" });
  //     setStatusComment("");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [visible, workStream, reset]);

  useEffect(() => {
    if (_roles.includes(1) || _roles.includes(26) || _roles.includes(56)) {
      setShowStatus([...status_Name_By_Assignee, ...status_Name_By_ProposalWriter_V, ...status_Name_By_BidManager, ...status_Name_By_ProposalWriter]);
    } else {
      let combined: Array<{ name?: string; value?: string }> = [];

      // Proposal-Writer verification step
      if (workStream !== null && (workStream?.status === "Uploaded" || workStream?.status === "Verified" || workStream?.status === "Non-Compliant") && _roles.includes(55)) {
        combined = [...combined, ...status_Name_By_ProposalWriter_V];
      }

      // Bid-Manager
      if (workStream !== null && (workStream?.status === "Verified" || workStream?.status === "Approved" || workStream?.status === "Rejected") && _roles.includes(53)) {
        combined = [...combined, ...status_Name_By_BidManager];
      }

      // Assignee closing after Approved
      if (workStream !== null && workStream?.status === "Approved" && workStream.assigned_To_ID !== undefined && workStream.assigned_To_ID !== null && workStream.assigned_To_ID > 0 && workStream.assigned_To_ID === loginObj.id) {
        combined = [...combined, ...status_Name_By_ProposalWriter];
      }

      // Normal assignee flow (this is what was getting skipped for dual-role users)
      if (workStream !== null && workStream?.status !== "Closed" && workStream?.status !== "Uploaded" && workStream?.status !== "Verified" && workStream?.status !== "Approved" && workStream?.assigned_To_ID !== undefined && workStream?.assigned_To_ID !== null && workStream?.assigned_To_ID > 0 && workStream.assigned_To_ID === loginObj.id) {
        const assigneeStatus = workStream?.status === "Created" ? status_Name_By_Assignee : status_Name_By_Assignee.filter((s) => s.value !== "Created");
        combined = [...combined, ...assigneeStatus];
      }

      // de-dupe in case both role paths offer the same target status
      const seen = new Set<string>();
      const deduped = combined.filter((s) => {
        if (!s.value || seen.has(s.value)) return false;
        seen.add(s.value);
        return true;
      });

      setShowStatus(deduped);
    }

    if (visible && workStream) {
      reset({ status: workStream.status ?? "" });
      setStatusComment("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, workStream, reset]);

  // const save = async (data: { status: string }) => {
  //   if (!workStream) return;

  //   if (_roles.includes(1) || _roles.includes(26) || _roles.includes(56)) {
  //   } else if (_roles.includes(53)) {
  //     // Bid-Manager
  //     if (workStream?.status === "Verified" || workStream?.status === "Approved" || workStream?.status === "Rejected") {
  //     } else {
  //       toast.current.show({ severity: "warn", detail: "Can Not Updated Status", life: 3000 });
  //       return;
  //     }
  //   } else if (_roles.includes(55)) {
  //     // Proposal-Writer
  //     if (workStream?.status === "Uploaded" || workStream?.status === "Verified" || workStream?.status === "Non-Compliant" || workStream?.status === "Rejected") {
  //     } else if (workStream?.status === "Approved") {
  //     } else {
  //       toast.current.show({ severity: "warn", detail: "Can Not Updated Status", life: 3000 });
  //       return;
  //     }
  //   } else {
  //     if (workStream?.status === "Uploaded" || workStream?.status === "Non-Compliant" || workStream?.status === "Rejected" || workStream?.status === "Closed") {
  //       toast.current.show({ severity: "warn", detail: "Can Not Updated Status", life: 3000 });

  //       return;
  //     }
  //   }
  //   if (data.status === "Uploaded" && !workStream.hasDocument && !(_roles.includes(1) || _roles.includes(26) || _roles.includes(56))) {
  //     toast.current.show({
  //       severity: "warn",
  //       detail: "Please upload at least one document before changing the status to Uploaded.",
  //       life: 3000,
  //     });
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const response = await Fetch("Tender_Mast/UpdateWorkStreamStatus", "PUT", { id: workStream.id, status: data.status, Status_Comment: statusComment }, null, toast);
  //     if (response?.ok) {
  //       toast.current.show({ severity: "success", detail: "Status updated successfully", life: 3000 });
  //       reset();
  //       onHide();
  //       onSuccess();
  //       setStatusComment("");
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const save = async (data: { status: string }) => {
    if (!workStream) return;

    const isAdmin = _roles.includes(1) || _roles.includes(26) || _roles.includes(56);

    const isBidManagerAllowed = _roles.includes(53) && (workStream?.status === "Verified" || workStream?.status === "Approved" || workStream?.status === "Rejected");

    const isProposalWriterAllowed = _roles.includes(55) && (workStream?.status === "Uploaded" || workStream?.status === "Verified" || workStream?.status === "Non-Compliant" || workStream?.status === "Rejected");

    const isAssignee = workStream.assigned_To_ID !== undefined && workStream.assigned_To_ID !== null && workStream.assigned_To_ID > 0 && workStream.assigned_To_ID === loginObj.id;

    const isAssigneeClosing = isAssignee && workStream?.status === "Approved";

    const isAssigneeFlow = isAssignee && workStream?.status !== "Closed" && workStream?.status !== "Uploaded" && workStream?.status !== "Verified" && workStream?.status !== "Approved";

    if (!(isAdmin || isBidManagerAllowed || isProposalWriterAllowed || isAssigneeClosing || isAssigneeFlow)) {
      toast.current.show({ severity: "warn", detail: "Can Not Updated Status", life: 3000 });
      return;
    }

    if (data.status === "Uploaded" && !workStream.hasDocument && !isAdmin) {
      toast.current.show({
        severity: "warn",
        detail: "Please upload at least one document before changing the status to Uploaded.",
        life: 3000,
      });
      return;
    }

    setLoading(true);
    try {
      const response = await Fetch("Tender_Mast/UpdateWorkStreamStatus", "PUT", { id: workStream.id, status: data.status, Status_Comment: statusComment }, null, toast);
      if (response?.ok) {
        toast.current.show({ severity: "success", detail: "Status updated successfully", life: 3000 });
        reset();
        onHide();
        onSuccess();
        setStatusComment("");
      }
    } finally {
      setLoading(false);
    }
  };

  const onHideDialog = () => {
    reset();
    onHide();
    setStatusComment("");
  };

  return (
    <Dialog header="Workstream Status" visible={visible} modal style={{ width: "30vw" }} onHide={onHideDialog}>
      <form onSubmit={handleSubmit(save)}>
        <div className="p-fluid formgrid grid">
          <JVDropdown required column={3} label="Status" control={control} name="status" options={showStatus} optionLabel="name" optionValue="value" placeholder="Select Status" error={errors.status?.message} />
          <div className="field col-12">
            <label>Comment</label>
            <InputTextarea value={statusComment} onChange={(e) => setStatusComment(e.target.value)} rows={4} cols={30} className="w-full" placeholder="Enter Status Comment" />
          </div>
          <div className="field col-12 flex justify-content-end gap-2">
            <Button label="Save" icon="pi pi-check" type="submit" disabled={!isDirty} loading={loading} />
            <Button label="Cancel" type="button" className="p-button-secondary" onClick={onHideDialog} />
          </div>
        </div>
      </form>
    </Dialog>
  );
};

export default WorkStreamStatus;
